import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import CloseIcon from '../CloseIcon'

const CloseButton = styled.button.attrs(({ dataTestId }) => ({
  a11yTitle: 'Close',
  'data-testid': dataTestId,
  plain: true,
}))`
  border-style: none;
  background-color: transparent;
  color: #999999;
  :hover {
    svg {
      transition: color 0.4s ease-in-out;
      color: #e1523d;
    }
  }
`

CloseButton.propTypes = {
  dataTestId: PropTypes.string.isRequired,
  icon: PropTypes.node,
  onClick: PropTypes.func,
}

CloseButton.defaultProps = {
  icon: <CloseIcon />,
  dataTestId: 'styled-closedButton-testid',
}

export default CloseButton



// WEBPACK FOOTER //
// ./src/components/CloseButton/CloseButton.styles.js